import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';
import { IApp } from '../../stores/AllStores';
import { Layout } from './../../components/layout';
import { PortalSearch } from './PortalSearch';
import { PortalCart } from './PortalCart';
import { PortalCheckout } from './PortalCheckout';
import { PortalItemPicture } from './PortalPicture';

// Component
@inject('store')
@observer
class PortalMain extends React.Component<IApp, {}> {

    constructor(props: IApp) {
        super(props);
    }

    public render() {
        return (
            <Layout>

                <PortalSearch />

                {(this.props.store.user.permissionId === 3) && (
                    <PortalCart />
                )}

                <PortalCheckout />

                <PortalItemPicture
                    images={this.props.store.gallery.images}
                    onClose={this.closeGallery}
                />

            </Layout>
        );
    }

    @action private closeGallery = () => {
        this.props.store.gallery.hideAllImages();
    }
}

export default PortalMain;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/portal/PortalMain.tsx